import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance1qq3nwu3zphmj as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance3r68caydq4mko as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance1f6yngk98x7z6 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      d6t(writer, customScalarAdapters, value) {
        writer.n4a('id');
        get_playerIdAdapter().t3x(writer, customScalarAdapters, value.m6q_1);
        writer.n4a('name');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.n6q_1);
        writer.n4a('email');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.o6q_1);
        var tmp = value.p6q_1;
        if (tmp instanceof Present()) {
          writer.n4a('badge');
          present(nullable(Badge_ResponseAdapter_instance)).r3y(writer, customScalarAdapters, value.p6q_1);
        }
        writer.n4a('callSignAdjective');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.q6q_1);
        writer.n4a('callSignNoun');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.r6q_1);
        var tmp_0 = value.s6q_1;
        if (tmp_0 instanceof Present()) {
          writer.n4a('imageURL');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.s6q_1);
        }
        var tmp_1 = value.t6q_1;
        if (tmp_1 instanceof Present()) {
          writer.n4a('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).r3y(writer, customScalarAdapters, value.t6q_1);
        }
        writer.n4a('unvalidatedEmails');
        list(get_StringAdapter()).p3y(writer, customScalarAdapters, value.u6q_1);
        writer.n4a('pins');
        list(obj(PinInput_InputAdapter_instance)).p3y(writer, customScalarAdapters, value.v6q_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.d6t(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instance2asphtnknnzjz,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
